import React from 'react';
import { Redirect } from 'react-router-dom';
import { useAuth } from '../context/contextAuth';

const InitialRoute = () => {
    const {user} = useAuth();
    return user ? user.is_admin ? <Redirect to="/admin" /> : <Redirect to="/dashboard" /> : <Redirect to="/auth" /> 
}

export default InitialRoute;